// FilletDragInput — Fusion-style live-индикатор радиуса при drag за стрелку
// fillet/chamfer. Появляется при pointerdown по стрелке, обновляется при
// каждом move. Юзер может ввести точное значение и Enter — radius применится.
//
// Связь с FilletPreview через window-callbacks:
//   __kubikonCadFilletDragStart({ value, clientX, clientY })
//   __kubikonCadFilletDragMove({ value, clientX, clientY })
//   __kubikonCadFilletDragEnd()

import React, { useEffect, useRef, useState } from 'react';
import useCadStore from '../store/useCadStore';
import cl from '../view3d/GizmoDragInput.module.css';


const FilletDragInput = () => {
    const updatePendingFeature = useCadStore((s) => s.updatePendingFeature);
    const [state, setState] = useState(null);
    // null | { value, x, y, manual }
    const inputRef = useRef(null);

    useEffect(() => {
        window.__kubikonCadFilletDragStart = ({ value, clientX, clientY }) => {
            setState({
                value,
                x: clientX + 16,
                y: clientY - 8,
                manual: false,
            });
        };
        window.__kubikonCadFilletDragMove = ({ value, clientX, clientY }) => {
            setState((prev) => {
                if (!prev) return prev;
                if (prev.manual) return prev;
                return { ...prev, value, x: clientX + 16, y: clientY - 8 };
            });
        };
        window.__kubikonCadFilletDragEnd = () => {
            // Не закрываем при отпускании ЛКМ — даём шанс юзеру набрать значение
            // и нажать Enter. Закроем после Enter / Escape / клик мимо.
        };
        return () => {
            delete window.__kubikonCadFilletDragStart;
            delete window.__kubikonCadFilletDragMove;
            delete window.__kubikonCadFilletDragEnd;
        };
    }, []);

    // Закрываем когда выходим из fillet-режима
    const pendingKind = useCadStore((s) => s.pendingFeature?.kind);
    useEffect(() => {
        if (pendingKind !== 'fillet' && pendingKind !== 'chamfer') {
            setState(null);
        }
    }, [pendingKind]);

    if (!state) return null;
    const { value, x, y } = state;

    const applyAndClose = () => {
        const v = Math.max(0.1, Math.round(value * 100) / 100);
        const cur = useCadStore.getState().pendingFeature;
        const tick = ((cur && cur.previewTick) || 0) + 1;
        updatePendingFeature({ radius: v, previewTick: tick });
        setState(null);
    };

    const onKey = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            applyAndClose();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            setState(null);
        }
    };

    return (
        <div
            className={cl.box}
            style={{ left: x, top: y, borderColor: '#6dc36d' }}
            onPointerDown={(e) => {
                e.stopPropagation();
                setState((prev) => prev ? { ...prev, manual: true } : prev);
                setTimeout(() => inputRef.current?.focus(), 0);
            }}
        >
            <span className={cl.axisBadge} style={{ background: '#6dc36d' }}>R</span>
            <input
                ref={inputRef}
                type="number"
                step="any"
                min="0.1"
                className={cl.input}
                value={Math.round(value * 100) / 100}
                onChange={(e) => {
                    const v = parseFloat(e.target.value);
                    if (!isNaN(v)) {
                        setState((prev) => prev ? { ...prev, value: v, manual: true } : prev);
                        // Бампаем previewTick → live-preview запускается
                        const cur = useCadStore.getState().pendingFeature;
                        const tick = ((cur && cur.previewTick) || 0) + 1;
                        updatePendingFeature({ radius: Math.max(0.1, v), previewTick: tick });
                    }
                }}
                onKeyDown={onKey}
            />
            <span className={cl.unit}>мм</span>
            <button className={cl.okBtn} onClick={applyAndClose} title="Применить (Enter)">✓</button>
        </div>
    );
};

export default FilletDragInput;
